import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';
let pending = false;
window.addEventListener('click', async event => {
  const button = event.target.closest?.('[data-varevo-bundle-quantity]');
  const group = button?.closest('[data-varevo-bundle]');
  if (!group) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  if (pending) return;
  const error = group.querySelector('[data-varevo-bundle-error]');
  const root = window.Shopify?.routes?.root || '/';
  const quantity = Math.max(0, Number(button.dataset.varevoBundleQuantity) || 0);
  const scope = group.closest('cart-items-component') || document;
  const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(n => n.dataset.sectionId))].slice(0,5);
  pending = true;
  group.querySelectorAll('button').forEach(n => { n.disabled = true; });
  error.textContent = '';
  const deferred = CartLinesUpdateEvent.createPromise();
  deferred.promise.catch(() => {});
  try {
    const currentResponse = await fetch(root + 'cart.js');
    if (!currentResponse.ok) throw new Error('Handlekurven kunne ikke hentes.');
    const current = await currentResponse.json();
    const members = current.items.filter(n => n.properties?._varevo_bundle === group.dataset.varevoBundle);
    if (!members.length) throw new Error('Pakken er endret. Oppdater siden.');
    const updates = Object.fromEntries(members.map(n => [n.key, quantity]));
    scope.dispatchEvent(new CartLinesUpdateEvent({ action: quantity ? 'update' : 'remove', context: 'cart', lines: members.map(n => ({merchandiseId:String(n.variant_id),quantity})), promise: deferred.promise }));
    const response = await fetch(root + 'cart/update.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates,sections:sections.join(','),sections_url:window.location.pathname + (window.varevoPreviewThemeId ? '?preview_theme_id=' + encodeURIComponent(window.varevoPreviewThemeId) : '')})});
    const cart = await response.json();
    if (!response.ok || cart.status) throw new Error(cart.description || 'Pakken kunne ikke oppdateres.');
    deferred.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{items:cart.items,sections:cart.sections,itemCount:cart.item_count,source:'varevo-bundle',didError:false}});
  } catch(e) {
    deferred.reject(e);
    error.textContent = e.message;
    scope.dispatchEvent(new CartErrorEvent({error:e.message,code:'SERVICE_UNAVAILABLE'}));
  } finally {
    pending = false;
    group.querySelectorAll('button').forEach(n => { n.disabled = false; });
  }
}, {capture:true});
